module.exports = {
      id: "icon-user-usage",
      viewBox: "0 0 50 50",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-user",
      toString: function () {
        return this.url;
      }
    }